const PATH_PERMISSION_RULES = [
  // Fresh Produce. Ordered most-specific-first like the rest of this table, so
  // '/agri/intake' is matched before the '/agri' module prefix.
  { prefix: '/agri/intake', permission: 'agri.intake.view' },
  { prefix: '/agri/farms', permission: 'agri.growers.view' },
  { prefix: '/agri/certifications', permission: 'agri.certifications.view' },
  { prefix: '/agri/settlement', permission: 'agri.settlement.view' },
  { prefix: '/agri/consignments', permission: 'agri.consignments.view' },
  { prefix: '/agri/waste', permission: 'agri.waste.view' },
  { prefix: '/agri/pallets', permission: 'agri.pallets.view' },
  { prefix: '/agri/picks', permission: 'agri.picking.view' },
  { prefix: '/agri/reports', permission: 'nav.agri.reports' },
  { prefix: '/agri/quality-tests', permission: 'agri.quality.test.view' },
  { prefix: '/agri/harvests', permission: 'agri.harvest.view' },
  { prefix: '/agri/cold-chain', permission: 'agri.coldchain.view' },
  { prefix: '/agri/pack-specs', permission: 'agri.packspecs.view' },
  { prefix: '/agri/traceability', permission: 'agri.trace.view' },
  { prefix: '/agri/claims', permission: 'agri.claims.view' },
  { prefix: '/agri/contracts', permission: 'agri.contracts.view' },
  { prefix: '/agri/deductions', permission: 'agri.deductions.view' },
  { prefix: '/agri/packing-runs', permission: 'agri.packing.view' },
  // Field Agronomy. Above the '/agri' fallback for the same reason as the rest:
  // this table matches by prefix in order, so the module-level rule would
  // otherwise swallow every agronomy path and resolve it to nav.agri.
  { prefix: '/agri/agronomy/inputs', permission: 'agri.inputs.view' },
  { prefix: '/agri/agronomy', permission: 'agri.agronomy.view' },
  { prefix: '/agri', permission: 'nav.agri' },

  { prefix: '/inventory/import-price-lists', permission: 'inventory.price_lists.import_batch.manage' },
  { prefix: '/inventory/groups', permission: 'inventory.groups.view' },
  { prefix: '/inventory/price-lists', permission: 'inventory.price_lists.view' },
  { prefix: '/inventory/variant-attributes', permission: 'inventory.variants.view' },
  { prefix: '/inventory/adjustments', permission: 'inventory.adjustments.create' },
  // Cost & margin reports, above the /inventory/reports rule so they resolve to
  // the narrower key (migration 250).
  { prefix: '/inventory/reports/costing', permission: 'inventory.costs.view' },
  { prefix: '/inventory/reports/valuation', permission: 'inventory.costs.view' },
  { prefix: '/inventory/reports/fifo-costing', permission: 'inventory.costs.view' },
  { prefix: '/inventory/reports/gross-margin', permission: 'inventory.costs.view' },
  { prefix: '/finance/dashboard', permission: 'nav.finance.dashboard' },
  { prefix: '/finance/reports', permission: 'nav.finance.reports' },
  { prefix: '/finance/vat-reconciliation', permission: 'finance.vat_reconciliation.manage' },
  { prefix: '/finance/banking', permission: 'finance.banking.view' },
  { prefix: '/finance/opening-balances', permission: 'finance.opening_balances.manage' },
  { prefix: '/finance', permission: 'nav.finance' },
  { prefix: '/customers/reports', permission: 'nav.customers.reports' },
  { prefix: '/customers', permission: 'nav.customers' },
  { prefix: '/suppliers/reports', permission: 'nav.suppliers.reports' },
  { prefix: '/suppliers', permission: 'nav.suppliers' },
  { prefix: '/inventory/reports', permission: 'nav.inventory.reports' },
  { prefix: '/inventory', permission: 'nav.inventory' },
  { prefix: '/orders/reports', permission: 'nav.orders.reports' },
  { prefix: '/orders', permission: 'nav.orders' },
  { prefix: '/pos/reports', permission: 'nav.pos.reports' },
  { prefix: '/pos/hq-dashboard', permission: 'nav.pos.hq_dashboard' },
  { prefix: '/pos', permission: 'nav.pos' },
  { prefix: '/manufacturing/reports', permission: 'nav.manufacturing.reports' },
  { prefix: '/manufacturing', permission: 'nav.manufacturing' },
  { prefix: '/projects/reports', permission: 'nav.project.reports' },
  { prefix: '/projects', permission: 'nav.project' },
  { prefix: '/delivery/reports', permission: 'nav.delivery.reports' },
  { prefix: '/delivery', permission: 'nav.delivery' },
  // Top-level on purpose. A driver must not hold nav.delivery (see
  // routes/driverDeliveries.js), and any path under /delivery/ would be blocked
  // by RbacRouteGate's candidate-key check on nav.delivery regardless of what
  // else the driver holds.
  { prefix: '/my-deliveries', permission: 'nav.my_deliveries' },
  { prefix: '/procurement/settings', permission: 'procurement.settings.manage' },
  { prefix: '/procurement', permission: 'nav.procurement' },
  { prefix: '/crm', permission: 'nav.crm' },
  { prefix: '/qai-reports', permission: 'nav.qai' },
  { prefix: '/qai-dashboards', permission: 'nav.qai' },
  { prefix: '/credit-control', permission: 'nav.credit_control' },
  { prefix: '/express-market', permission: 'nav.express_market' },
  { prefix: '/settings', permission: 'nav.settings' },
  { prefix: '/tasks', permission: 'nav.tasks' },
  { prefix: '/company-dashboard', permission: 'nav.dashboard' },
  { prefix: '/user-dashboard', permission: 'nav.dashboard' },
  { prefix: '/', permission: 'nav.dashboard' },
];

const TOP_LEVEL_LABEL_MAP = {
  Dashboard: 'nav.dashboard',
  Finance: 'nav.finance',
  Banking: 'finance.banking.view',
  Customers: 'nav.customers',
  Suppliers: 'nav.suppliers',
  Procurement: 'nav.procurement',
  Inventory: 'nav.inventory',
  'Order Entry': 'nav.orders',
  POS: 'nav.pos',
  Manufacturing: 'nav.manufacturing',
  Project: 'nav.project',
  Delivery: 'nav.delivery',
  CRM: 'nav.crm',
  'Q AI Report Generator': 'nav.qai',
  'Q AI Dashboard Generator': 'nav.qai',
  'Credit Control': 'nav.credit_control',
  'Express Market': 'nav.express_market',
  'My To-Do': 'nav.tasks',
  Settings: 'nav.settings',
};

const REPORTS_LABEL_MAP = {
  Finance: 'nav.finance.reports',
  'Order Entry': 'nav.orders.reports',
  Customers: 'nav.customers.reports',
  Suppliers: 'nav.suppliers.reports',
  Inventory: 'nav.inventory.reports',
  POS: 'nav.pos.reports',
  Manufacturing: 'nav.manufacturing.reports',
  Project: 'nav.project.reports',
  Delivery: 'nav.delivery.reports',
};

// Pages a user may open by holding one action key, whatever the module's
// menu key says. A Warehouse Manager or Manufacturing Supervisor raises POs from
// Reorder / Replenishment / Work Order shortages without having Order Entry in
// their menu: the PO form (and the PO it just saved) must open for them, the
// rest of /orders must not.
const DIRECT_ACCESS_RULES = [
  { pattern: /^\/orders\/purchase-orders\/(new|\d+)\/?$/, permission: 'orders.purchase_orders.create' },
  // Finance Dashboard drill-down; the server admits nav.finance.reports too.
  { pattern: /^\/inventory\/reports\/valuation\/?$/, permission: 'nav.finance.reports' },
];

export const directAccessPermissionForPath = (pathname = '/') => {
  const path = String(pathname || '/');
  const rule = DIRECT_ACCESS_RULES.find((r) => r.pattern.test(path));
  return rule ? rule.permission : null;
};

export const resolveNavPermissionForPath = (pathname = '/') => {
  const path = String(pathname || '/');
  if (path.startsWith('/settings/users-roles')) return 'settings.users_roles.manage';
  if (path.startsWith('/settings/audit-log')) return 'settings.audit_log.view';
  if (path.startsWith('/settings/report-layouts')) return 'settings.report_layouts.manage';
  if (path.startsWith('/settings/user-defined-fields')) return 'settings.udf.manage';

  for (const rule of PATH_PERMISSION_RULES) {
    if (rule.prefix === '/') {
      if (path === '/') return rule.permission;
      continue;
    }
    if (path === rule.prefix || path.startsWith(`${rule.prefix}/`)) {
      return rule.permission;
    }
  }

  return null;
};

const resolveMenuPermission = (item, parentTrail = []) => {
  if (item.permission) {
    return item.permission;
  }

  if (item.path) {
    return resolveNavPermissionForPath(item.path);
  }

  if (!parentTrail.length) {
    return TOP_LEVEL_LABEL_MAP[item.label] || null;
  }

  if (item.label === 'Reports') {
    const rootLabel = parentTrail[0];
    return REPORTS_LABEL_MAP[rootLabel] || null;
  }

  return null;
};

const navKeySegment = (value) => String(value || '')
  .replace(/[^a-z0-9]+/gi, '.')
  .replace(/^\.+|\.+$/g, '')
  .toLowerCase();

// Derive a stable navbar-visibility key for a menu node. This is the single
// key used by the sidebar filter, the System Tree editor, and route gating.
//   1. explicit item.permission (e.g. inventory.groups.view, nav.pos.hq_dashboard)
//   2. top-level module/link and 'Reports' section -> canonical catalog key
//      (nav.pos, nav.express_market, nav.pos.reports) so role templates apply
//   3. nested leaf -> unique key from its path (e.g. /pos/setup -> nav.pos.setup)
// A nested "landing" child whose path is the bare module base (Till Monitor
// '/pos', Listing '/customers') would otherwise collide with the module key and
// hiding it would hide the whole module — such a child is disambiguated with its
// label (e.g. nav.pos.till.monitor).
export const navKeyForMenuItem = (item, parentTrail = []) => {
  if (!item) return null;
  if (item.permission) return item.permission;

  const isTopLevel = !parentTrail.length;
  const isReportsGroup = item.label === 'Reports' && Array.isArray(item.children) && item.children.length > 0;
  if (isTopLevel || isReportsGroup) {
    const canonical = resolveMenuPermission(item, parentTrail);
    if (canonical) return canonical;
  }

  if (item.path) {
    const slug = String(item.path).replace(/^\/+/, '').replace(/[/-]/g, '.').toLowerCase();
    if (!slug) return resolveMenuPermission(item, parentTrail);
    const segCount = String(item.path).replace(/^\/+|\/+$/g, '').split('/').filter(Boolean).length;
    if (!isTopLevel && segCount <= 1) {
      return `nav.${slug}.${navKeySegment(item.label)}`;
    }
    return `nav.${slug}`;
  }

  return `nav.${[...parentTrail, item.label].map(navKeySegment).join('.')}`;
};

// Cumulative candidate nav keys for a URL, e.g. /pos/setup -> ['nav.pos', 'nav.pos.setup'].
// Uses the same slug transform as navKeyForMenuItem so a hidden menu leaf is matched
// even when the current URL carries deeper segments (e.g. /inventory/items/123).
export const candidateNavKeysForPath = (pathname = '/') => {
  const segments = String(pathname || '/').split('/').filter(Boolean);
  const keys = [];
  let acc = '';
  for (const seg of segments) {
    acc = acc ? `${acc}.${seg}` : seg;
    keys.push(`nav.${acc.replace(/-/g, '.').toLowerCase()}`);
  }
  return keys;
};

export const filterMenuItemsByPermission = (
  items,
  canPermission,
  isNavHidden = () => false,
  parentTrail = []
) => {
  if (!Array.isArray(items)) return [];

  return items
    .map((item) => {
      const requiredPermission = resolveMenuPermission(item, parentTrail);
      if (requiredPermission && !canPermission(requiredPermission)) {
        return null;
      }

      // Opt-out leaf visibility: hide only when explicitly denied for this user.
      if (isNavHidden(navKeyForMenuItem(item, parentTrail))) {
        return null;
      }

      if (!item.children || !item.children.length) {
        return item;
      }

      const nextTrail = parentTrail.length ? parentTrail : [item.label];
      const children = filterMenuItemsByPermission(item.children, canPermission, isNavHidden, nextTrail);
      if (!children.length && !item.path) {
        return null;
      }

      return {
        ...item,
        children,
      };
    })
    .filter(Boolean);
};
